// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MapPOIS_wrapper__37xeX","map_title_style":"MapPOIS_map_title_style__2w1gj"};